
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Luxuryacthree() {



    const cardData =
    {
        keyword: 'Luxury Ac 36 Seater Bharat Benz Bus on Rent Pune',
        heading: 'Amruta Travels: Luxury Ac 36 Seater Bharat Benz Bus on Rent Pune',
        headingDescription: 'Amruta Travels offers Luxury AC 36 Seater BharatBenz Bus on Rent in Pune, delivering superior travel comfort for medium-sized groups. Whether it’s a corporate tour, wedding party, school picnic, or religious trip, our 36-seater BharatBenz buses provide top-class amenities, spacious interiors, and advanced air-conditioning for a premium travel experience. With professional drivers, punctual service, and well-maintained buses, Amruta Travels ensures your journey is safe, stylish, and stress-free.',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',


  "topPlaces": [
    {
      "title": "Mahabaleshwar",
      "description": "Located around 120 km from Pune, Mahabaleshwar is a picturesque hill station in the Western Ghats, known for its cool climate, evergreen forests, and stunning viewpoints such as Arthur’s Seat, Wilson Point (the highest point), and Kate's Point. The region is famous for its strawberry farms, especially during the Strawberry Festival held in spring. Other attractions include Venna Lake for boating, Mapro Garden for strawberry-based treats, and ancient temples like Panchganga and Mahabaleshwar Temple. It's a popular destination for families, honeymooners, and nature enthusiasts seeking a refreshing escape from city life."
    },
    {
      "title": "Lonavala & Khandala",
      "description": "Just 66 km from Pune, these twin hill stations in the Sahyadri range offer a perfect blend of natural beauty and adventure. Lonavala is known for its misty mountains, lush greenery, and monsoon waterfalls like Kune and Bhivpuri. Attractions include Bhushi Dam, Tiger’s Leap, Rajmachi Fort, and Karla & Bhaja Caves. Khandala is equally famous for its panoramic valley views and trekking routes. The area is ideal for a weekend drive, with scenic routes and roadside chikki stalls that add to the charm of this quick getaway."
    },
    {
      "title": "Shirdi",
      "description": "About 190 km from Pune, Shirdi is a sacred town revered by followers of Sai Baba. The Sai Baba Samadhi Mandir is the main attraction, drawing millions of devotees every year. Pilgrims can also visit Dwarkamai, Chavadi, and the Sai Heritage Village. The spiritual ambiance, combined with well-maintained infrastructure and religious events, makes Shirdi a prominent destination for those seeking peace, healing, and spiritual growth."
    },
    {
      "title": "Goa",
      "description": "Located nearly 450 km from Pune, Goa is India’s premier beach destination, known for its lively culture, golden beaches, and Portuguese heritage. From North Goa’s party hotspots like Baga, Anjuna, and Calangute to South Goa’s serene stretches like Palolem and Colva, there’s a vibe for every traveler. Apart from beaches, visitors can explore Aguada Fort, Basilica of Bom Jesus, spice plantations, vibrant flea markets, and indulge in thrilling water sports. Goa is also a haven for foodies, offering authentic seafood, Goan curries, and beachside shacks serving refreshing cocktails."
    },
    {
      "title": "Nashik",
      "description": "Around 210 km from Pune, Nashik is a city of immense cultural, historical, and spiritual significance. It is one of the four cities where the Kumbh Mela is held. Attractions include the ancient Kalaram Temple, Muktidham Temple, Pandavleni Caves, and Trimbakeshwar Temple—an important Jyotirlinga. Nashik is also the wine capital of India, home to Sula Vineyards, York Winery, and many tasting tours. The Godavari River adds to its charm, making it a harmonious blend of spirituality and leisure tourism."
    },
    {
      "title": "Alibaug",
      "description": "Situated about 140 km from Pune, Alibaug is a tranquil coastal town offering a perfect mix of beaches, history, and nature. Popular beaches include Nagaon, Alibaug Beach, and Kashid Beach, all great for swimming, sunbathing, and water sports. The iconic Kolaba Fort, accessible during low tide, adds historical value to the destination. You can also explore Korlai Fort, Kanakeshwar Temple, and local seafood cuisine. Ideal for weekend trips, Alibaug also offers ferry services from Mumbai for added convenience."
    },
    {
      "title": "Kolhapur",
      "description": "Roughly 235 km from Pune, Kolhapur is a vibrant city known for its divine Mahalaxmi Temple, which draws pilgrims throughout the year. The city is equally famous for its spicy cuisine, Kolhapuri chappals, and traditional arts. Attractions include Rankala Lake for evening strolls, Panhala Fort offering panoramic views, and the New Palace Museum showcasing royal heritage. With its rich cultural identity and warm hospitality, Kolhapur is ideal for heritage and culinary tourism."
    },
    {
      "title": "Lavasa",
      "description": "Just 60 km from Pune, Lavasa is an Italian-inspired planned city nestled in the Sahyadri hills. It features beautiful waterfronts, European-style architecture, and a peaceful atmosphere perfect for a quick weekend escape. Activities include kayaking, zip-lining, and lakeside cycling. With cozy resorts, conference centers, and nature trails, Lavasa attracts both families and corporate travelers. The weather remains pleasant most of the year, enhancing its appeal as a rejuvenating destination close to Pune."
    },
    {
      "title": "Satara & Kaas Plateau",
      "description": "About 120 km from Pune, Satara serves as the base for exploring the Kaas Plateau—popularly known as the 'Valley of Flowers' of Maharashtra. The plateau, a UNESCO World Natural Heritage site, bursts into a riot of colors with over 850 species of wildflowers during the monsoon season. Satara is also known for Ajinkyatara Fort, Thoseghar Waterfalls, and Sajjangad Fort. The natural beauty and biodiversity make this region a paradise for trekkers, botanists, and photographers."
    },
    {
      "title": "Aurangabad",
      "description": "Situated 235 km from Pune, Aurangabad is a historical treasure trove, offering insights into ancient art, architecture, and culture. The city is home to the world-famous Ajanta and Ellora Caves, adorned with exquisite carvings and paintings dating back to 2nd century BCE. Other attractions include Bibi Ka Maqbara (a replica of the Taj Mahal), Daulatabad Fort, and Aurangabad Caves. The city is also a gateway to Grishneshwar Jyotirlinga and Paithani saree shopping, making it a must-visit for heritage lovers."
    }
  ],

     "services": [
    {
      "name": "Bharat Benz 36 Seater AC Bus Pune",
      "description": "Rent a 36 Seater Bharat Benz AC bus in Pune for your group travel needs. Ideal for corporate events, weddings, and family outings, this luxurious bus offers a comfortable and smooth journey with modern amenities and experienced drivers."
    },
    {
      "name": "36 Seater Luxury AC Bus on Rent in Pune",
      "description": "Our 36 Seater luxury AC buses for rent in Pune provide an elevated travel experience. With plush seating, air conditioning, and ample space for luggage, these buses are perfect for corporate trips, weddings, and other high-end events."
    },
    {
      "name": "Bharat Benz Bus Rental Pune 36 Seater",
      "description": "Opt for our Bharat Benz 36 Seater bus rental in Pune, offering a premium travel experience with modern comforts, spacious interiors, and professional drivers. Suitable for large group events, corporate travel, and destination weddings."
    },
    {
      "name": "Corporate & Wedding Bus 36 Seater",
      "description": "Our 36 Seater Bharat Benz bus is the perfect choice for transporting guests or employees for corporate events and weddings. With ample seating, air conditioning, and stylish interiors, it offers a comfortable and luxurious travel experience."
    },
    {
      "name": "Pune to Outstation 36 Seater AC Bus",
      "description": "Travel to outstation destinations comfortably in our 36 Seater Bharat Benz AC bus. Whether it's a corporate trip, religious tour, or family vacation, we ensure a comfortable and hassle-free journey with our well-maintained buses."
    },
    {
      "name": "36 Seater Bus Hire for School Excursions",
      "description": "Our 36 Seater AC Bharat Benz bus is perfect for school excursions and educational trips. With air-conditioned comfort and reliable safety features, our buses offer a secure and enjoyable experience for students and teachers alike."
    },
    {
      "name": "Event Transport Bus Rental Pune",
      "description": "Looking for transportation for an event in Pune? Rent our 36 Seater Bharat Benz AC bus for a comfortable and stylish travel option. Suitable for conferences, exhibitions, corporate functions, and other large events, these buses offer both comfort and reliability."
    },
    {
      "name": "36 Seater Bharat Benz for Office Staff",
      "description": "For office staff transportation, our 36 Seater Bharat Benz bus offers ample seating, air conditioning, and a smooth ride. Perfect for daily commutes or special office events, this bus provides comfort and efficiency for your team."
    },
    {
      "name": "AC Bharat Benz Bus for Marriage Functions",
      "description": "Make your wedding day special with our 36 Seater AC Bharat Benz bus. Ideal for transporting guests, our luxurious buses provide a comfortable and stylish ride to and from the wedding venue, ensuring a memorable experience."
    },
    {
      "name": "AC Coach for Religious Tours",
      "description": "Embark on a religious journey with our 36 Seater AC Bharat Benz bus, designed for comfort and convenience. Whether it’s a visit to temples or pilgrimage destinations, our buses provide a peaceful and comfortable journey for spiritual groups."
    },
    {
      "name": "Bharat Benz 36 Seater Bus for Conferences",
      "description": "Rent our 36 Seater Bharat Benz bus for conferences and business meetings. With ample space for attendees and professional amenities, this bus ensures a comfortable and efficient transport solution for corporate gatherings."
    },
    {
      "name": "36 Seater Bus Hire Hadapsar",
      "description": "Looking for a 36 Seater bus rental in Hadapsar? Our Bharat Benz buses provide a comfortable and reliable transportation solution for corporate trips, weddings, school excursions, and group tours."
    },
    {
      "name": "Pimpri Chinchwad Bus on Rent 36 Seater",
      "description": "Rent a 36 Seater bus in Pimpri Chinchwad with Amruta Travels for your next group event or outing. Our Bharat Benz buses ensure a smooth and comfortable ride, with air conditioning and ample space for your group."
    },
    {
      "name": "Pune to Ashtavinayak 36 Seater Bus Rental",
      "description": "Book a 36 Seater Bharat Benz bus for your trip from Pune to Ashtavinayak. Perfect for religious tours, this bus offers a comfortable ride with air conditioning, ensuring a smooth and peaceful journey for your group."
    },
    {
      "name": "Luxury Group Tour Bus 36 Seater",
      "description": "Rent our 36 Seater luxury Bharat Benz bus for your next group tour. Ideal for sightseeing, corporate trips, and family vacations, our buses provide a premium travel experience with comfortable seating, air conditioning, and ample space."
    }
  ],
  "tableData": [
    ["Bharat Benz 36 Seater AC Bus Pune", "36 Seater Luxury AC Bus on Rent in Pune"],
    ["Bharat Benz Bus Rental Pune 36 Seater", "Corporate & Wedding Bus 36 Seater"],
    ["Pune to Outstation 36 Seater AC Bus", "36 Seater Bus Hire for School Excursions"],
    ["Event Transport Bus Rental Pune", "36 Seater Bharat Benz for Office Staff"],
    ["AC Bharat Benz Bus for Marriage Functions", "AC Coach for Religious Tours"],
    ["Bharat Benz 36 Seater Bus for Conferences", "36 Seater Bus Hire Hadapsar"],
    ["Pimpri Chinchwad Bus on Rent 36 Seater", "Pune to Ashtavinayak 36 Seater Bus Rental"],
    ["Luxury Group Tour Bus 36 Seater"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Luxury AC 36 Seater Bharat Benz Bus on Rent in Pune",
    "WhyChoosedescription": "Amruta Travels offers Luxury AC 36 Seater Bharat Benz buses for rent in Pune, providing an upscale travel experience for medium to large groups. Whether it’s a corporate event, family tour, or a wedding guest transport, our Bharat Benz buses deliver both style and comfort."
  },
  {
    "WhyChooseheading": "Spacious and Luxurious AC Comfort for Groups",
    "WhyChoosedescription": "Our 36 Seater Bharat Benz buses are designed for groups seeking superior comfort. With plush, reclining seats, premium air-conditioning, and ample space, your group can enjoy a smooth and comfortable ride for both short and long journeys."
  },
  {
    "WhyChooseheading": "Modern Amenities for an Enjoyable Journey",
    "WhyChoosedescription": "These buses are equipped with state-of-the-art features, including advanced air conditioning, leather-like seats, wide windows, ambient lighting, and an entertainment system, ensuring a luxurious and enjoyable travel experience for your group."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "We offer competitive pricing for Luxury AC 36 Seater Bharat Benz rentals with clear, all-inclusive rates. There are no hidden charges—our fees cover fuel, tolls, driver allowances, taxes, and more, making it easier to plan your budget without any surprises."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers for Safety and Comfort",
    "WhyChoosedescription": "Our drivers are highly experienced, trained, and licensed. They are well-versed in Pune’s routes and major outstation destinations, ensuring safe, timely, and comfortable travel while maintaining a courteous and professional demeanor throughout the journey."
  },
  {
    "WhyChooseheading": "Perfect for Corporate Travel, Weddings, and Family Outings",
    "WhyChoosedescription": "The Luxury 36 Seater Bharat Benz bus is ideal for corporate trips, group vacations, weddings, or special events. Its combination of luxury and capacity ensures that your group travels together in style, without compromising on comfort."
  },
  {
    "WhyChooseheading": "Well-Maintained Fleet for a Smooth Ride",
    "WhyChoosedescription": "Our fleet of Luxury AC 36 Seater Bharat Benz buses is meticulously maintained and regularly serviced. Each bus undergoes thorough checks to ensure a smooth, trouble-free, and safe journey for all passengers."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking and 24/7 Customer Support",
    "WhyChoosedescription": "Booking a Luxury AC 36 Seater Bharat Benz bus with Amruta Travels is easy. You can book online, by phone, or by visiting our office. Our dedicated 24/7 customer support team is available to assist with any queries, bookings, or special requests."
  }
]


















    }

const faqData = [
  {
    question: 'Can I rent a Luxury AC 36-seater Bharat Benz bus in Pune with Amruta Travels?',
    answer: 'Yes, Amruta Travels offers Luxury AC 36-seater Bharat Benz buses for rent in Pune. These buses are perfect for large groups, offering a premium travel experience for corporate events, family outings, tours, and long-distance travel.',
  },
  {
    question: 'What amenities are available in the Luxury AC 36-seater Bharat Benz bus?',
    answer: 'Our Luxury AC 36-seater Bharat Benz buses are equipped with comfortable plush seating, air conditioning, ample legroom, entertainment systems, USB charging ports, overhead storage, and a clean, luxurious interior for a top-class travel experience.',
  },
  {
    question: 'Is the Luxury AC 36-seater Bharat Benz bus available for both local and outstation travel?',
    answer: 'Yes, the Luxury AC 36-seater Bharat Benz bus is available for both local city travel in Pune as well as outstation trips to popular destinations like Lonavala, Mahabaleshwar, Shirdi, Mumbai, and more.',
  },
  {
    question: 'Is a driver included in the Luxury AC 36-seater Bharat Benz bus rental?',
    answer: 'Yes, all Luxury AC 36-seater Bharat Benz bus rentals from Amruta Travels include a professional, experienced, and licensed driver who ensures a safe, comfortable, and timely journey.',
  },
  {
    question: 'How much does it cost to rent a Luxury AC 36-seater Bharat Benz bus in Pune?',
    answer: 'Rental charges for the Luxury AC 36-seater Bharat Benz bus depend on factors like distance, trip duration, and additional services. Typically, rates start from ₹60–₹75 per km. For a precise quote, please contact us with your travel details.',
  },
  {
    question: 'Is the Luxury AC 36-seater Bharat Benz bus comfortable for long journeys?',
    answer: 'Yes, the Luxury AC 36-seater Bharat Benz bus is designed for long journeys, offering ample space, plush seating, air conditioning, and modern amenities to ensure maximum comfort throughout your trip.',
  },
  {
    question: 'Are the Luxury AC 36-seater Bharat Benz buses well-maintained and sanitized?',
    answer: 'Absolutely. All our Luxury AC 36-seater Bharat Benz buses are regularly inspected, thoroughly cleaned, and sanitized before each trip to ensure the highest standards of safety and hygiene for our passengers.',
  },
  {
    question: 'How do I book a Luxury AC 36-seater Bharat Benz bus in Pune?',
    answer: 'Booking a Luxury AC 36-seater Bharat Benz bus is simple! You can book online via our website or contact our customer support team. We offer easy booking, transparent pricing, and quick assistance for all your queries.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Deepak Kumar',
    role: 'Senior Manager, Pune',
    text: 'We rented a Luxury AC 36-seater Bharat Benz bus from Amruta Travels for an executive retreat. The bus was luxurious, comfortable, and perfect for our team. The ride was smooth, and the amenities were top-notch!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Priya Mehta',
    role: 'Event Coordinator',
    text: 'I booked a Luxury AC 36-seater Bharat Benz bus for a wedding guest transport. The bus was very spacious, well-maintained, and the air conditioning kept everyone comfortable. It made the trip even more special for our guests.',
    rating: 5,
  },
];


























































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Luxury AC 36 Seater Bharat Benz Bus on Rent in Pune",
  "image": "https://bushireinpune.com/assets/images/36-seater-bharat-benz-bus.jpg",
  "description": "Book a Luxury AC 36 Seater Bharat Benz Bus on Rent in Pune for weddings, corporate events, school excursions, and outstation tours like Ashtavinayak Darshan. Amruta Travels provides spacious, comfortable, air-conditioned Bharat Benz coaches with professional drivers for group travel from Hadapsar, Pimpri Chinchwad, and across Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "14589"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5600",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/luxury-ac-36-seater-bharat-benz-bus-rent-pune"
  }
};








    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Luxury AC 36 Seater Bharat Benz Bus on Rent in Pune | Wedding & Corporate Coach</title>
  <meta 
    name="description" 
    content="Rent a luxury AC 36 seater Bharat Benz bus in Pune for corporate events, weddings, school trips, and group tours to Ashtavinayak, Shirdi, or other outstations. Book with Amruta Travels for premium comfort." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/85.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Luxuryacthree;